import React from "react";
import {
  Box,
  Dialog,
  IconButton,
  Typography,
  createStyles,
  withStyles
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { InlineWidget } from "react-calendly";
import { magicLinkColors, magicLinkRadius } from "./magicLinkTokens";

interface Props {
  open: boolean;
  meetingLink: string;
  onClose: () => void;
  classes: Record<string, string>;
}

const styles = (theme: any) =>
  createStyles({
    paper: {
      width: 748,
      maxWidth: "calc(100% - 32px)",
      borderRadius: magicLinkRadius.card,
      padding: 24,
      boxSizing: "border-box",
      [theme.breakpoints.down("xs")]: {
        padding: 16
      }
    },
    top: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 12
    },
    title: {
      fontFamily: "Nunito Sans",
      fontSize: "19px",
      fontWeight: 600,
      lineHeight: "26px",
      color: magicLinkColors.textStrong
    },
    subtitle: {
      fontFamily: "Nunito Sans",
      fontSize: "14px",
      lineHeight: "20px",
      color: magicLinkColors.text,
      marginTop: 4
    },
    widget: {
      marginTop: 16,
      "& .calendly-inline-widget": {
        height: "500px !important"
      }
    }
  });

const BookCallDialog = ({ open, meetingLink, onClose, classes }: Props) => (
  <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
    <Box className={classes.top}>
      <Box>
        <Typography component="h2" className={classes.title}>
          Book a call
        </Typography>
        <Typography className={classes.subtitle}>
          Book a 15-minute call to confirm your selection and get started!
        </Typography>
      </Box>
      <IconButton aria-label="Close" size="small" onClick={onClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <Box className={classes.widget}>
      {open && <InlineWidget url={meetingLink} />}
    </Box>
  </Dialog>
);

export default withStyles(styles)(BookCallDialog);
